import { render, staticRenderFns } from "./editBusinessDetail.vue?vue&type=template&id=4ba04df7&scoped=true"
import script from "./editBusinessDetail.vue?vue&type=script&lang=js"
export * from "./editBusinessDetail.vue?vue&type=script&lang=js"
import style0 from "./editBusinessDetail.vue?vue&type=style&index=0&id=4ba04df7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba04df7",
  null
  
)

export default component.exports